import * as React from 'react';
import { Redirect, Route, Switch, RouteProps } from 'react-router-dom';
import { AllComponents } from 'src/components';
import { RouterConfig } from 'src/routers/urlConfig';

interface IMRouterProps extends RouteProps {
  menuItem: RouterConfig.IMenuItems;
}

class MRouter extends React.Component<IMRouterProps> {
  constructor(props: IMRouterProps) {
    super(props);
  }

  render() {
    const { menuItem } = this.props;
    return (
      <Switch>
        {Object.keys(menuItem).map((key: string) =>
          menuItem[key].map((menu: RouterConfig.IMenuData) => {
            const route = (item: RouterConfig.IMenuData) => {
              // 此处需要确保children中的item.component不能为空
              const Component = AllComponents[item.component || ''];
              // const Component = item.component;
              return <Route key={item.path} exact={true} path={item.path} render={props => <Component {...props} />} />;
            };
            return !!menu.component ? route(menu) : (menu.children || []).map(item => route(item));
          })
        )}
        <Route render={() => <Redirect to={RouterConfig.Urls.notFound} />} />
      </Switch>
    );
  }
}

export default MRouter;



// WEBPACK FOOTER //
// ./src/routers/MRouter.tsx